import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {fetchAuthSession, getCurrentUser, signOut} from '@aws-amplify/auth';
import {Hub} from 'aws-amplify/utils';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private userSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public user$ = this.userSubject.asObservable();

  private tokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public token$ = this.tokenSubject.asObservable();

  private isLoggedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isLogged: Observable<boolean> = this.isLoggedSubject.asObservable();

  constructor() {
    // Initialize isLogged based on the current user
    this.getCurrentUser().then();

    // Listen for Amplify Auth events to keep state in sync
    Hub.listen('auth', ({payload}) => {
      switch (payload.event) {
        case 'signedIn':
          this.getCurrentUser().then();
          break;
        case 'signedOut':
          this.userSubject.next(null);
          this.tokenSubject.next(null);
          this.isLoggedSubject.next(false);
          break;
      }
    });
  }

  async getCurrentUser(): Promise<any> {
    try {
      const {username, userId, signInDetails} = await getCurrentUser();
      const user = {username, userId, signInDetails};
      this.userSubject.next(user);
      this.isLoggedSubject.next(true);
      return user;
    } catch (error) {
      this.userSubject.next(null);
      this.isLoggedSubject.next(false);
      return null;
    }
  }

  async getIdToken(): Promise<string | undefined> {
    try {
      const {tokens} = await fetchAuthSession({forceRefresh: true});
      return tokens?.idToken?.toString();
    } catch (err) {
      console.log(err);
      return undefined;
    }
  }

  async signOut(): Promise<void> {
    try {
      await signOut();
      this.userSubject.next(null);
      this.tokenSubject.next(null);
      this.isLoggedSubject.next(false);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  }
}
